import { useApi } from "@/hooks/use-api";

interface WorkspaceTenant {
  enabledModules?: string[];
}

interface WorkspaceContextResponse {
  activeTenant: WorkspaceTenant | null;
}

export function useActiveTenantModule(moduleName: string): {
  isLoading: boolean;
  isEnabled: boolean;
} {
  const { data, isLoading } = useApi<WorkspaceContextResponse>("/v1/platform/workspace-context");
  const enabledModules = data?.activeTenant?.enabledModules ?? [];

  return {
    isLoading,
    isEnabled: enabledModules.includes(moduleName),
  };
}
